import { msg } from '@lingui/core/macro';
import type { ChatErrorCode } from 'modules/chat/domain/interfaces/chat-error';
import type { MessageDescriptor } from 'shared/i18n';

export const CHAT_ERROR_MESSAGES: Record<ChatErrorCode, MessageDescriptor> = {
  FORBIDDEN: msg`Недостаточно прав для использования ИИ-ассистента в этом турнире.`,
  UNAVAILABLE: msg`Сервис ИИ-ассистента временно недоступен, попробуйте позже.`,
  TOKEN_LIMIT: msg`Превышен месячный лимит токенов ИИ-ассистента. Попробуйте позже.`,
  RATE_LIMIT: msg`Слишком много запросов. Попробуйте позже.`,
  NO_ACTIVE_TOURNAMENT: msg`Нет активного турнира`,
  SEND_FAILED: msg`Не удалось отправить сообщение`,
  LOAD_FAILED: msg`Не удалось загрузить историю`,
  CLEAR_FAILED: msg`Не удалось очистить историю`,
};
